<template>
    <div class="range">
      <span>{{label}}</span>
      <input type="range" :name="name" :min="min" :max="max" :step="step" class="range" @input="getRangeVal($event)"/>
    </div>
</template>

<script>
export default {
  props : { 
    label : {type : String, default:""},
    name : {type : String, default:"range"},
    max : {type : Number, default:2},
    min : {type : Number, default:0},
    step : {type : Number, default:0.01},
  },
  methods : {
    getRangeVal(e) {
      this.$emit('input',e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .range {
    display:flex;
    flex-direction: column;
    // align-items:center;
    padding : .5rem 0;
  }
  input[type=range] {
    margin : 0 .5rem;
  }

</style>


// WEBPACK FOOTER //
// src/components/global/Range.vue